<template>
  <BreadCrumb class="hidden sm:block" />
  <ArticlePage :entry="entry" :seomatic="seomatic" />
</template>

<script>
import { SeomaticFragment, EntryPageFragment } from '@/mixins/entryPage';
import { stripLocale } from '@/utils/i18n';
import gql from 'graphql-tag';
import ArticlePage, { ArticlePageFragment } from '@/components/article/ArticlePage';
import BreadCrumb from '@/components/layout/BreadCrumb';

const ArticleQuery = gql`
  query ArticleQuery($site: String!, $uri: String!, $slug: String!) {
    entry(site: [$site], slug: [$slug], section: "article") {
      ...EntryPageFragment
      ...ArticlePageFragment
    }
    knowledgeRoot: entry(site: [$site], section: "knowledge", level: 1) {
      title
      uri
    }
    seomatic(site: $site, uri: $uri, asArray: true) {
      ...SeomaticFragment
    }
  }
  ${SeomaticFragment}
  ${EntryPageFragment}
  ${ArticlePageFragment}
`;

export default defineNuxtComponent({
  name: 'ArticlePageController',

  components: {
    ArticlePage,
    BreadCrumb,
  },

  async asyncData() {
    const { $craftRequest } = useNuxtApp();
    const route = useRoute();
    const slug = route.params.slug;
    const { locale } = useNuxtApp().$i18n;
    const uri = stripLocale(route.path, locale.value);
    const variables = { site: locale.value, uri, slug };
    const { entry, seomatic, knowledgeRoot } = await $craftRequest(ArticleQuery, variables);

    return { entry, seomatic, knowledgeRoot };
  },

  data() {
    return {
      knowledgeRoot: null,
      entryPage: null,
    };
  },
  created() {
    this.entryPage = useEntryPage(this.entry, this.seomatic, { content_category: 'knowledge' });

    // Article breadcrumbs use knowledgeRoot as parent instead of entry.parent
    const { setBreadcrumbs } = useBreadcrumbs();
    setBreadcrumbs([
      {
        label: this.knowledgeRoot?.title,
        route: {
          name: `knowledge-index___${this.$i18n.locale}`,
        },
      },
      {
        label: this.entry.title,
        route: {
          name: `article-slug___${this.$i18n.locale}`,
          params: { slug: this.entry.slug },
        },
      },
    ]);
  },
});
</script>
